import { _request } from '@@/utils/request'
import CONFIG from '@@/config'

export const {
  SMTSERVICE_HOST
} = CONFIG

export const smtRequest = {
  get: (url, data, config = {
    customMsg: true
  }) => _request.get(`${SMTSERVICE_HOST}${url}`, data, {...config}),
  post: (url, data, config = {
    customMsg: true
  }) => _request.post(`${SMTSERVICE_HOST}${url}`, data, {...config})
}

// 获取用户信息
export const getcustomerinfo = data =>smtRequest.get('/ajax/getcustomerinfo?v=pc', data)

// 获取用户信息
export const feedbackApi = data =>smtRequest.post('/feedback/add', data)